module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title44"
    }
  }), _c('div', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781429919197_tp01",
      "id": "toctitle42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781429919197_ack01",
      "id": "toctitle1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("acknowledgments")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781429919197_fm01",
      "id": "toctitle2"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Prologue")])])]), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429919197_p01",
      "id": "toctitle3"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The First Trimester")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p01#title4",
      "id": "toctitle4"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("thursday, february 14")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p01#title5",
      "id": "toctitle5"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("friday, march 22")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p01#title6",
      "id": "toctitle6"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("saturday, march 23")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p01#title7",
      "id": "toctitle7"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("sunday, march 24")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p01#title8",
      "id": "toctitle8"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("thursday, march 28")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p01#title9",
      "id": "toctitle9"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("monday, april 1")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p01_b#title10",
      "id": "toctitle10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("tuesday, april 2")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429919197_p02",
      "id": "toctitle11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Second Trimester")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p02#title12",
      "id": "toctitle12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("sunday, may 5")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p02#title13",
      "id": "toctitle13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("saturday, may 11")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p02#title14",
      "id": "toctitle14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("monday, may 13")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p02#title15",
      "id": "toctitle15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("tuesday, may 14")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p02#title16",
      "id": "toctitle16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("friday, may 24")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p02#title17",
      "id": "toctitle17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("monday, june 3")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p02#title18",
      "id": "toctitle18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("sunday, june 23")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p02#title19",
      "id": "toctitle19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("wednesday, june 26")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p02#title20",
      "id": "toctitle20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("tuesday, july 2")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p02#title21",
      "id": "toctitle21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("wednesday, july 3")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p02#title22",
      "id": "toctitle22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("monday, july 8")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p02#title23",
      "id": "toctitle23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("monday, july 15")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p02#title24",
      "id": "toctitle24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("thursday, july 18")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p02_b#title25",
      "id": "toctitle25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("friday, july 19")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p02_b#title26",
      "id": "toctitle26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("monday, july 22")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p02_b#title27",
      "id": "toctitle27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("wednesday, july 24")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p02_b#title28",
      "id": "toctitle28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("monday, july 29")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429919197_p03",
      "id": "toctitle29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Third Trimester")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p03#title30",
      "id": "toctitle30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("monday, august 5")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p03#title31",
      "id": "toctitle31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("friday, august 9")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p03#title32",
      "id": "toctitle32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("saturday, august 10")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p03#title33",
      "id": "toctitle33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("monday, august 12")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p03#title34",
      "id": "toctitle34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("opening night: friday, august 23")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p03#title35",
      "id": "toctitle35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("sunday, august 25")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p03#title36",
      "id": "toctitle36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("monday, august 26")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p03#title37",
      "id": "toctitle37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("wednesday, august 28")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p03#title38",
      "id": "toctitle38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("saturday, september 7")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p03#title39",
      "id": "toctitle39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("monday, october 7, columbus day")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429919197_p03#title40",
      "id": "toctitle40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("saturday, october 12")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_alsoby",
    attrs: {
      "href": "#/e9781429919197_als01",
      "id": "toctitle46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Also by")])]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_praisePage",
    attrs: {
      "href": "#/e9781429919197_pra01",
      "id": "toctitle41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Praise for Alisa Valdes-Rodriguez and Her Vibrant Novels")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781429919197_cop01",
      "id": "toctitle43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-092cfe6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429919197_toc01.vue
// module id = 60
// module chunks = 0